import { useCallback, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { Pagination, SortParams } from '../../../types/interfaces'
import { parse, stringify } from '../../utils/query-string'

export const useNavigationAndSortEarningsTable = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const currentPage = Number(searchParams.get('page')) || 1
  const currentPageSize = Number(searchParams.get('size')) || 10
  const [pagination, setPagination] = useState<Pagination>({
    page: currentPage,
    pageSize: currentPageSize,
  })

  const [sortParams, setSortParams] = useState<SortParams>(
    (parse(searchParams.get('sort') ?? '') as SortParams) || {}
  )

  const handleChangePagination = useCallback(
    (paginationParams: Pagination) => {
      const currentSearchParams = Object.fromEntries(searchParams.entries())

      setSearchParams({
        ...currentSearchParams,
        page: String(paginationParams.page),
        size: String(paginationParams.pageSize),
      })

      setPagination((prev) => ({ ...prev, ...paginationParams }))
    },
    [searchParams, setSearchParams]
  )

  const handleSort = useCallback(
    (sort: SortParams) => {
      const currentSearchParams = Object.fromEntries(searchParams.entries())

      setSearchParams({
        ...currentSearchParams,
        sort: stringify(sort as object),
      })

      setSortParams(sort)
    },
    [searchParams, setSearchParams]
  )

  return {
    handleChangePagination,
    handleSort,
    pagination,
    sortParams,
  }
}
